import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchTeamById } from '../../../../api/index.js';
import { CircularProgress, Typography } from '@mui/material';
import FormTeam from '../create/FormTeam.js';
import useFetch from '../../../../v2/hooks/useFetch.js';

const EditPlayer = () => {

    const { id } = useParams()

    const { data, isLoading, error, fetchData } = useFetch(fetchTeamById, [id]);

    useEffect(() => {
        if(!id)
            return

        fetchData()

    }, [id])

    useEffect(() => {

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])


    if(isLoading)
        return <CircularProgress/>
    
    if(!data)
        return <Typography sx={{m : 3}}>Aucune équipe trouvée</Typography>

    return <FormTeam team={data[0]} />

}

export default EditPlayer